import { getComparePageBySlug } from "@/app/seo-compare";
import { CompareLayout } from "./CompareLayout";

export default function HotlineVsApi() {
  const page = getComparePageBySlug("hotline-vs-api");
  if (!page) return null;
  return <CompareLayout page={page} />;
}
